/**
 * APS Region utilities for Autodesk Platform Services
 *
 * Regions:
 * - US (1): Default US region, streaming API: streamingV2
 * - EMEA (2): Europe/Middle East/Africa, streaming API: streamingV2_EU
 */

export const ApsRegion = {
  US: 1,
  EMEA: 2
};

/**
 * Region display names for UI
 */
export const ApsRegionLabels = {
  [ApsRegion.US]: 'US',
  [ApsRegion.EMEA]: 'EMEA'
};

/**
 * Get streaming API endpoint based on region
 * @param {number|string} region - ApsRegion value or string ('US', 'EMEA')
 * @returns {string} - 'streamingV2' or 'streamingV2_EU'
 */
export function getStreamingApi(region) {
  if (region === ApsRegion.EMEA || region === 'EMEA' || region === 2) {
    return 'streamingV2_EU';
  }
  return 'streamingV2';
}

/**
 * Get region string for API headers
 * @param {number} region - ApsRegion value
 * @returns {string} - 'US' or 'EMEA'
 */
export function getRegionString(region) {
  return region === ApsRegion.EMEA ? 'EMEA' : 'US';
}

/**
 * Parse region from API response
 * @param {string|number} region - Region value from API
 * @returns {number} - ApsRegion enum value
 */
export function parseRegion(region) {
  if (region === 'EMEA' || region === 2 || region === ApsRegion.EMEA) {
    return ApsRegion.EMEA;
  }
  return ApsRegion.US;
}

/**
 * Get region options for dropdown selectors
 * @returns {Array} - Array of { id, name, streamingApi }
 */
export function getRegionOptions() {
  return [
    { id: ApsRegion.US, name: 'US', streamingApi: 'streamingV2' },
    { id: ApsRegion.EMEA, name: 'EMEA', streamingApi: 'streamingV2_EU' }
  ];
}

export default {
  ApsRegion,
  ApsRegionLabels,
  getStreamingApi,
  getRegionString,
  parseRegion,
  getRegionOptions
};
